
import { defineComponent, ref, reactive, computed, toRefs } from 'vue';
import { vLoading, ElDialog, ElForm, ElFormItem, ElInput, ElRadio, ElButton, FormRules, FormInstance, ElMessage } from 'element-plus';

import { StyleInput } from '@/components/common';
import { doCreateRank, RankCreateFormData } from '@/services';
import EditorUpload from '@/components/Editor/Fields/EditorUpload.vue';

export default defineComponent({
    directives: {
        vLoading
    },
    components: {
        ElDialog,
        ElForm,
        ElFormItem,
        ElInput,
        ElRadio,
        ElButton,
        StyleInput,
        EditorUpload
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        'update:visible' (val:boolean) {
            return true;
        }
    },
    setup (props, { emit }) {
        const {
            visible
        } = toRefs(props);
        const localVisible = computed({
            get: () => visible.value,
            set: (val) => emit('update:visible', val)
        });
        const formLoading = ref(false);
        const formEdit = reactive<RankCreateFormData>({
            title: '',
            desc: '',
            styles: [],
            primary_img: '',
            type: {
                index: 2,
                name: '专辑榜'
            },
            topic: {
                index: 1,
                name: '风格榜'
            }
        });

        const onChooseStyle = (styles:any) => {
            formEdit.styles = styles;
        };

        const createRank = ref<FormInstance>();
        const doConfirmEdit = () => {
            // eslint-disable-next-line no-unused-expressions
            createRank.value?.validate(valid => {
                if (!valid) {
                    return;
                }

                formLoading.value = true;

                doCreateRank(formEdit).then(() => {
                    ElMessage.success('创建成功');
                    localVisible.value = false;
                }).finally(() => {
                    formLoading.value = false;
                });
            });
        };

        const rules = reactive<FormRules>({
            title: [
                {
                    required: true,
                    message: '请输入活动名称',
                    trigger: 'blur'
                },
                {
                    min: 3,
                    max: 20,
                    message: '长度在 3 到 20 个字符',
                    trigger: 'blur'
                }
            ],
            desc: [
                {
                    required: true,
                    message: '请输入活动名称',
                    trigger: 'blur'
                }
            ],
            primary_img: [
                {
                    required: true,
                    message: '请输入图片链接',
                    type: 'url',
                    trigger: 'blur'
                }
            ]
        });

        return {
            localVisible,
            formLoading,
            doConfirmEdit,
            rules,
            formEdit,
            onChooseStyle,
            createRank
        };
    }
});
